import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref } from "vue"

import { ref, onMounted, watch, onActivated } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { getCosIdBindCode } from '@/api/gucangSales/customerCenter'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { debounce } from 'lodash-es'

const __default__ = { name: 'SerialSelect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: [String, Array, Number]
  },
  label: {
    type: [String, Array]
  },
  cosId: {
    type: String
  },
  requiredCosId: {
    type: Boolean,
    default: true
  },
  view: {
    type: Boolean
  },
  stage: {
    type: Array,
    default: () => {
      return [2, 3, 4] // 2.潜在 3签约 4 成交
    }
  },
  disabledData: {
    type: Array,
    default: () => {
      return []
    }
  }
},
  emits: ['update:value', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props

const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = __emit
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      if (searchTxt.value) {
        fetchCode('')
      }
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  emit('update:value', value)
  emit('change', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const fetchCode = debounce((txt: string) => {
  searchTxt.value = txt.trim()
  pageNumber.value = 1
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  getCosIdBindCode({
    pageNumber: pageNumber.value,
    pageSize: 100,
    arkCode: searchTxt.value,
    stage: props.stage,
    cosId: props.cosId
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  if (props.requiredCosId && !props.cosId) {
    return
  }
  fetch()
})
onActivated(() => {
  if (props.requiredCosId && !props.cosId) {
    return
  }
  if (pageNumber.value === 1) {
    optionPage.value = []
    fetch()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_CosSelect = _resolveComponent("CosSelect")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CosInputView, {
        key: 0,
        value: data.value
      }, null, 8, ["value"]))
    : (_openBlock(), _createBlock(_component_CosSelect, {
        key: 1,
        value: data.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
        style: {"width":"100%"},
        onPopupScroll: popupScroll,
        showSearch: true,
        "filter-option": false,
        onSearch: _unref(fetchCode),
        placeholder: "请选择",
        onChange: change
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPage.value, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              disabled: __props.disabledData.includes(item.arkCode) && data.value !== item.arkCode ? true : false,
              key: item.id,
              value: item.arkCode
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.arkCode), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "onSearch"]))
}
}

})